import SearchBar from './SearchBar.svelte';

// const target = document.getElementById('quick-finder');

// const app = new QuickFinder({
// 	target: target,
// });

// export default app;

window.SearchBar = function (options) {
    return new SearchBar(options);
};